import { initMiniLightbox, showMiniLgithbox, configureMiniLightbox, setTitleWidth } from "./mini-lightbox";

const addImageSource = (imagePath,desc) => {
	//const imgElemContainer = document.querySelector('.js-lightboxContent');
  const imgElem = document.querySelector('.js-lightboxImage');

  const txtElem = document.querySelector('.imageTitle');
  txtElem.style.display = 'none';
  imgElem.setAttribute("src", imagePath);
  if(desc == undefined || desc == null){
	  desc= "";
  }
  txtElem.innerHTML= desc;
  imgElem.decode().then(() => {
  	setTitleWidth();
  });
  window.addEventListener('resize', setTitleWidth);
}

const activateImageTag = () => {
  const elemList = document.querySelectorAll('.js-lbImage');
  if(elemList.length<=1){
  	const imageNavList = document.querySelectorAll('.imageNavPanel');
  	imageNavList.forEach(function(elem) {
  		elem.style.display = 'none';
  	});
  	//imageNav.css.style.display = 'none';
  }
  elemList.forEach(function(elem) {
    elem.addEventListener("click", function(e) {
      addImageSource(e.target.getAttribute("data-fullpath"),e.target.getAttribute("data-text"));

      showMiniLgithbox();
    });
  });
}

const getNextImagePath = (currentImagePath) => {
  const imageList = document.querySelectorAll('.js-lbImage');
  for (let i = 0; i < imageList.length; i++) {
    const thisPath = imageList[i].getAttribute('data-fullPath');

    if (thisPath === currentImagePath) {
      const nextIndex = i < (imageList.length - 1) ? (i + 1) : 0;
      const nextPath = imageList[nextIndex].getAttribute('data-fullPath');;
      const nextText = imageList[nextIndex].getAttribute('data-text');

      return {'image': nextPath,'text':nextText};
    }
  }
}

const getPrevImagePath = (currentImagePath) => {
  const imageList = document.querySelectorAll('.js-lbImage');

  for (let i = 0; i < imageList.length; i++) {
    const thisPath = imageList[i].getAttribute('data-fullPath');

    if (thisPath === currentImagePath) {
      const previousIndex = (i > 0) ? (i - 1) : (imageList.length - 1);
      const prevPath = imageList[previousIndex].getAttribute('data-fullPath');
      const prevText = imageList[previousIndex].getAttribute('data-text');

      return {'image': prevPath,'text':prevText};
    }
  }
}

const activateNextButton = () => {
  const elem = document.querySelector('.js-lbImage__next');

  elem.addEventListener('click', function() {
    const imageElem = document.querySelector('.js-lightboxImage');
    const txtElem = document.querySelector('.imageTitle');
    txtElem.style.display = 'none';
    const nextImage = getNextImagePath(imageElem.getAttribute('src'));
    //imageElem.setAttribute('src', nextImagePath);
    addImageSource(nextImage.image, nextImage.text);
  })
}


const activatePrevButton = () => {
  const elem = document.querySelector('.js-lbImage__prev');

  elem.addEventListener('click', function() {
    const imageElem = document.querySelector('.js-lightboxImage');
    const txtElem = document.querySelector('.imageTitle');
    const prevImage = getPrevImagePath(imageElem.getAttribute('src'));

    txtElem.style.display = 'none';
    //imageElem.setAttribute('src', nextImagePath);

    addImageSource(prevImage.image, prevImage.text);
  })
}

const setupMiniLightbox = () => {
  const config = {
    'class': 'lightboxContainer',
    'content': `
        <div class="lightboxContent js-lightboxContent">
          <img class="js-lightboxImage">
          <a class="imageNavPanel imageNavPanel--left js-lbImage__prev" href="#">
            <i class="fa fa-chevron-circle-left fa-4x"></i>
          </a>
          <a class="imageNavPanel imageNavPanel--right js-lbImage__next" href="#">
            <i class="fa fa-chevron-circle-right fa-4x"></i>
          </a>
          <div class="imageTitle">
            <span>Here goes image title.</span>
          </div>
        </div>
      `
  }
  configureMiniLightbox(config);
}

export const prepareMiniLightBox = () => {
  initMiniLightbox();

  setupMiniLightbox();

  activateImageTag();

  activatePrevButton();

  activateNextButton();
}
